import { Observable, of, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs/operators';
import { APICONSTANTS } from '../../constants/api-constants';
import { HostnameService } from '../basic/hostname.service';
import { ProjetAgenceDemandeModel, ProjetAgenceModel, ProjetSchemaDescrModel } from '../../models/simple-types/projet-models.model';
import { GenericCrudService } from '../basic/generic.crud.service';
import { Injectable } from '@angular/core';

@Injectable()

export class ProjetAgenceDemandeService extends GenericCrudService<ProjetAgenceDemandeModel> {
  constructor(http: HttpClient, protected toastrService: ToastrService,
    protected hostnameService: HostnameService) {
    super(http, toastrService, APICONSTANTS.ROUTEPROJETDEMANDEAGENCE, hostnameService);
  }

  formatVal(descr, projObj, key) {
    let val = "";
    if (descr && descr.type == "select") {
      let opt = descr.props.options.find(opt => opt.value.toString() == projObj[key].toString());
      val = opt ? opt.label : projObj[key];
    } 
    else if (descr && descr.type == "checkbox") {
      val = projObj[key] == true ? "coché" : "décoché";
    } 
    else if (descr && descr.type == "input" && descr.props?.type == "date") {
      let splitDate = projObj[key].split("-");
      val = (splitDate.reverse()).join('/');
    }
    else 
    {
      val = projObj[key];
    }
    return val;
  }

  generateModif(projetSchemaDescr: ProjetSchemaDescrModel, oldProjetAgence: ProjetAgenceModel, newProjetAgence: ProjetAgenceModel): string {
    let modif = "<br>";
    let oldProjObj = JSON.parse(oldProjetAgence.projet);
    let newProjObj = JSON.parse(newProjetAgence.projet);
    let schemaObj = JSON.parse(projetSchemaDescr.schema);

    if (oldProjObj.length == 0) 
    {
      modif += "<b>Création Formulaire " + newProjetAgence.projetSchemaDescr.libelle + " :</b><br>";
      let countCrea = 0;
      for (const key in newProjObj) {
        countCrea++;
        let descr = schemaObj.find(desc => desc.key == key);
        let val = this.formatVal(descr, newProjObj, key);
        modif += "<b>" + (descr?.props ? descr.props.label : key) + " : </b>" + val + "<br>";
      }
      if (countCrea == 0) {
        modif += "Formulaire vierge"
      }
    } 
    else 
    {
      modif += "<b>Modification Formulaire " + newProjetAgence.projetSchemaDescr.libelle + " :</b><br>";
      const uniqueToOld: { [key: string]: any } = {};
      const uniqueToNew: { [key: string]: any } = {};
      const modified: { [key: string]: { oldValue: any; newValue: any } } = {};
    
      for (const key in oldProjObj) {
        if (!Object.keys(newProjObj).find(k => k == key)) {
          uniqueToOld[key] = oldProjObj[key];
        } else if (oldProjObj[key] != newProjObj[key]) {
          if (!newProjObj[key] && newProjObj[key] !== false) {
            uniqueToOld[key] = oldProjObj[key];
          } else if (!oldProjObj[key]  && oldProjObj[key] !== false) {
            uniqueToNew[key] = newProjObj[key];
          } else {
            modified[key] = { oldValue: oldProjObj[key], newValue: newProjObj[key] };
          }
        }
      }
      for (const key in newProjObj) {
        if (!Object.keys(oldProjObj).find(k => k == key)) {
          uniqueToNew[key] = newProjObj[key];
        }
      }

      let countOld = 0;
      for (const key in uniqueToOld) {
        countOld++;
        let descr = schemaObj.find(desc => desc.key == key);
        let oldVal = this.formatVal(descr, oldProjObj, key);
        modif += "Supression <b>" + (descr?.props ? descr.props.label : key) + " : </b>" + oldVal + "<br>";
      }
      let countNew = 0;
      for (const key in uniqueToNew) {
        countNew++;
        let descr = schemaObj.find(desc => desc.key == key);
        let newVal = this.formatVal(descr, newProjObj, key);
        modif += "Ajout <b>" + (descr?.props ? descr.props.label : key) + " : </b>" + newVal + "<br>";
      }
      let countModif = 0;
      for (const key in modified) {
        countModif++;
        let descr = schemaObj.find(desc => desc.key == key);
        let oldVal = this.formatVal(descr, oldProjObj, key);
        let newVal = this.formatVal(descr, newProjObj, key);
        modif += "Modifié <b>" + (descr?.props ? descr.props.label : key) + " : </b>" + oldVal + " -> " + newVal + "<br>";
      }

      if (countOld == 0 && countNew == 0 && countModif == 0) {
        modif += "Aucun changement"
      }
    }
    return (modif);
  }

  getFromAgence(agenceId: number): Observable<ProjetAgenceDemandeModel[]> {
    return this.http.get<ProjetAgenceDemandeModel[]>(APICONSTANTS.URLAPI.value + this.route + 'getFromAgence/' + agenceId).pipe(catchError(err => this.requestCatchError(err, 'GetFromAgence')));
  }

  requestCatchError(error, origineError): Observable<any> {
    let errorMessage = '';
    if (error.status === 400) {
      this.toastrService.error(error.error, 'Erreur client');
      errorMessage = `Error: ${error.error.message}`;
      return throwError(errorMessage);
    }
    if (error.error instanceof ErrorEvent) {
        // client-side error
        this.toastrService.error(origineError + '  a échoué.', 'Erreur client');
        errorMessage = `Error: ${error.error.message}`;
    } else {
        // server-side error
        this.toastrService.error(origineError + '  a échoué.', 'Erreur serveur');
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}